import type { Skill } from '../types/index';

export const skills: Skill[] = [
  // Frontend
  { 
    name: 'React', 
    level: 95, 
    category: 'frontend', 
    icon: 'react' 
  },
  { 
    name: 'React Native', 
    level: 90, 
    category: 'mobile', 
    icon: 'react' 
  },
  { 
    name: 'JavaScript', 
    level: 90, 
    category: 'frontend', 
    icon: 'javascript' 
  },
  { 
    name: 'TypeScript', 
    level: 85, 
    category: 'frontend', 
    icon: 'typescript' 
  },
  { 
    name: 'HTML5', 
    level: 95, 
    category: 'frontend', 
    icon: 'html5' 
  },
  { 
    name: 'CSS3', 
    level: 70, 
    category: 'frontend', 
    icon: 'css3' 
  },
  { 
    name: 'Material UI', 
    level: 80, 
    category: 'frontend', 
    icon: 'materialui' 
  },

  // Backend
  { 
    name: 'Python', 
    level: 100, 
    category: 'backend', 
    icon: 'python' 
  },
  { 
    name: 'Django', 
    level: 100, 
    category: 'backend', 
    icon: 'django' 
  },
  { 
    name: 'Java', 
    level: 100, 
    category: 'backend', 
    icon: 'java' 
  },
  { 
    name: 'C#', 
    level: 100, 
    category: 'backend', 
    icon: 'csharp' 
  },
  { 
    name: 'Node.js', 
    level: 100, 
    category: 'backend', 
    icon: 'nodejs' 
  },
  { 
    name: 'Spring Boot', 
    level: 85, 
    category: 'backend', 
    icon: 'springboot' 
  },

  // Mobile
  { 
    name: 'Kotlin', 
    level: 100, 
    category: 'mobile', 
    icon: 'kotlin' 
  },
  { 
    name: 'Android', 
    level: 85, 
    category: 'mobile', 
    icon: 'android' 
  },

  // Database
  { 
    name: 'MySQL', 
    level: 90, 
    category: 'database', 
    icon: 'mysql' 
  },
  { 
    name: 'PostgreSQL', 
    level: 80, 
    category: 'database', 
    icon: 'postgresql' 
  },
  { 
    name: 'H2', 
    level: 75, 
    category: 'database', 
    icon: 'h2' 
  },

  // Tools
  { 
    name: 'Linux', 
    level: 100, 
    category: 'tools', 
    icon: 'linux' 
  },
  { 
    name: 'Git', 
    level: 85, 
    category: 'tools', 
    icon: 'git' 
  },
  { 
    name: 'Docker', 
    level: 75, 
    category: 'tools', 
    icon: 'docker' 
  },
  { 
    name: 'NGINX', 
    level: 80, 
    category: 'tools', 
    icon: 'nginx' 
  },
  { 
    name: 'Unity', 
    level: 80, 
    category: 'tools', 
    icon: 'unity' 
  }
];
